import "./style.css";
import "./chrome.css";
import "./ui/transitions.css";
import { currentRoute, refreshRoute, registerRoute, startRouter } from "./router";
import { renderCountdownSticker } from "./views/countdownSticker";
import { renderCountdownChrome } from "./views/countdownChrome";
import { renderEditEvent } from "./views/editEvent";
import { renderOnboarding } from "./views/onboarding";
import { renderSettings } from "./views/settings";
import { startNotificationWatcher } from "./notify";
import { store, resolveLook } from "./state";
// iPad layouts: last, so they sit over each look's own CSS; all gated to an app 540pt+ wide.
import "./ipad/ipad.css";

const app = document.getElementById("app")!;

// iPhone draws <input switch> as the real iOS switch; Settings uses it when it can.
if ("switch" in HTMLInputElement.prototype) document.documentElement.classList.add("native-switch");

/** Paints the look onto <html> (data-theme / -layout / -skin / -variant) and the status-bar meta tags. */
function applyLook() {
  const look = resolveLook(store.get());
  const html = document.documentElement;
  html.dataset.theme = look.cssTheme;
  html.dataset.layout = look.layout;
  html.dataset.skin = look.skin;
  html.dataset.variant = look.variant;
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", look.bg);
  document.querySelector('meta[name="background-color"]')?.setAttribute("content", look.bg);
  document.querySelector('meta[name="color-scheme"]')?.setAttribute("content", look.dark ? "dark" : "light");
  return look;
}

let rendered = applyLook();
store.subscribe(() => {
  const look = applyLook();
  // Sticker and Neumorphic have their own countdown layouts, and the shared
  // one reads the theme when it builds, so a change of layout or stylesheet
  // while the countdown is on screen rebuilds the view. Skin and colourway
  // changes are pure CSS and don't.
  if (look.layout !== rendered.layout || look.cssTheme !== rendered.cssTheme) {
    rendered = look;
    if (currentRoute() === "/") refreshRoute();
  }
});

registerRoute("/", (root) => {
  return store.get().theme === "chrome" ? renderCountdownChrome(root) : renderCountdownSticker(root);
});
// First run gets the guided, one-question-at-a-time setup; editing an
// existing countdown keeps the single form.
registerRoute("/edit", (root) => (store.getPrimaryEvent() ? renderEditEvent(root) : renderOnboarding(root)));
registerRoute("/settings", renderSettings);

startRouter(app, "/");
startNotificationWatcher();

// The artifact build's phrase browser; dropped from the real app's bundle.
if (import.meta.env.MODE === "lab") void import("./lab");

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // offline/installability is a nice-to-have, not a hard requirement
    });
  });
}
